import { FolderContent } from '@/api/generatedApi';
import { GridColDef } from '@mui/x-data-grid-pro';
import { RenderName } from './cellDefinitions';

export const comparePageColumns: GridColDef<FolderContent>[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 300,
    minWidth: 270,
    filterable: false,
    sortable: false,
    flex: 1,
    renderCell: RenderName,
  },
];
